export default {
  id: 'rsrc.auditFlags',
  name: 'rsrc.auditFlags',
  displayName: 'Rsrc Flags',
  valueType: 'string*',
  objectType: 'rsrc',
  placement: {
    group: []
  },
  get: obj => {
    return obj?.metadata?.auditFlag ? Object.keys(obj.metadata.auditFlag) : null;
  }
};